import type { RowAction } from '@/components/ui/data-table/types';
import { labelMutations } from '@/features/labels/labels.queries';
import { executeMutation } from '@/utils/executeMutation';
import type { Label } from '@certhon/models';
import { Trash2 } from 'lucide-react';

export { adaptActionsForPanel } from '@/utils/adaptActionsForPanel';

/**
 * Get actions for a label - works for both row actions (table) and panel actions.
 *
 * No batch-delete endpoint exists for labels (PostgREST `PATCH` with a
 * `recnum=eq.X` filter is the only delete shape), so bulk delete uses
 * `tier: 'sequential'` — the generic runner iterates the per-row mutation.
 */
export function getLabelActions(): RowAction<Label>[] {
  const actions: RowAction<Label>[] = [];

  // Delete action
  actions.push({
    id: 'delete',
    icon: Trash2,
    label: 'Delete',
    variant: 'destructive',
    onCalled: async (label) => {
      await executeMutation(labelMutations.delete(), label.recnum);
    },
    bulk: { tier: 'sequential' },
  });

  return actions;
}
